"use client";

import React from "react";
import SectionHeading from "./section-heading";
import { motion } from "framer-motion";
import { useSectionInView } from "@/lib/hooks";

export default function About() {
  const { ref } = useSectionInView("About");

  return (
    <motion.section
      ref={ref}
      className="mb-28 max-w-[45rem] text-center leading-8 sm:mb-40 scroll-mt-28"
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.175 }}
      id="about"
    >
      <SectionHeading>About me</SectionHeading>
      <p>
        Building software before ChatGPT was introduced.
        <br />
        Hi, I'm Saddam — a full-stack engineer currently working at{" "}
        <span className="font-medium">FuseAI (backed by Y Combinator)</span>. I've
        worked extensively with the MERN ecosystem and delivered production
        solutions for QuickSync, FuseAI, Amanahfy, and Dekki. I handle
        end-to-end ownership across the stack, from architecture and data
        modeling to clean UI development and reliable deployments. I stay ahead
        of emerging technologies to deliver systems that are efficient, secure,
        and scalable.
      </p>
    </motion.section>
  );
}
